import { formatPrice } from "../../../../../utils/price.utils";

const PriceDetails = ({ order }) => {

    return (
        <div className="price-details">

            <div>
                <span>Sub Total</span>
                <span>{formatPrice(order.actual_order_values)}</span>
            </div>

            {order.first_coupon_code && (
                <div>
                    <span>Coupon [{order.first_coupon_code}]</span>
                    <span>-{formatPrice(order.first_coupon_discount)}</span>
                </div>
            )}

            <div>
                <span>Shipping Charges</span>
                <span>
                    {order.shipping_charges === 0 ? "Free" : formatPrice(order.shipping_charges)}
                </span>
            </div>

            <hr />

            <div className="total">
                <strong>Total</strong>
                <strong>{formatPrice(order.total_amount)}</strong>
            </div>

        </div>
    );
};

export default PriceDetails;